import { Component, OnInit } from '@angular/core';
import { HttpService } from '../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuerystoreService } from '../services/querystore.service';


@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.scss']
})
export class DocumentViewComponent implements OnInit {

  document: any;
  prevItem: string;
  nextItem: string;
  hits: string[];

  constructor(
    private http: HttpService,
    private route: ActivatedRoute,
    private router: Router,
    private hitsStore: QuerystoreService,
  ) {

  }

  // LESSON-PETER: Die ganze Logik war im constructor, allgemein
  //   empfiehlt es sich die Logik in ngOnInit zu packen, teils
  //   wurde das Dokument nicht geladen
  ngOnInit() {

    const id = this.route.snapshot.paramMap.get('id');

    this.hits = this.hitsStore.getAllHits();

    if (this.hits) {
      for (let i = 0; i < this.hits.length; i++) {
        if (this.hits[i] === id) {
          this.nextItem = this.hits[i + 1];
          this.prevItem = this.hits[i - 1];
        }
      }
    }

    this.http.document(id).subscribe(res => {
      this.document = res.hits.hits[0]['_source'];
      console.log(this.document);
    });

}


toDocument(id) {
  window.open('/suche#/document/' + id);
}


printDoc() {
  window.print();
}

prev() {
  this.router.navigateByUrl('/' , {skipLocationChange: true}).then(() =>
  this.router.navigate(['/document/' + this.prevItem]));
}

next() {
  this.router.navigateByUrl('/' , {skipLocationChange: true}).then(() =>
  this.router.navigate(['/document/' + this.nextItem]));
}



}



